import { createReducer } from 'typesafe-actions';
import { editorAction, editorState } from './types';
import * as actions from './actions';
import produce from 'immer';

import msg from '../../i18n/ko.json';

import { boxDefault, textDefault, buttonDefault, partitionDefault, linkDefault } from '../../config/components';

import { option } from '../../config/options';
import { applyContentData } from './saga';

const initialState: editorState = {
	contents: [],
	testGroup: undefined,
	selectedContentId: -1,
	prevSelectedContentId: -1,
	markedToolbar:{
		contentId: -1,
		currentIndex: -1,
		itemType: ''
	},
	emailId: -1,
	email: {
		id: -1,
		listId: -1
	},
	listVars: [],
	listInfo: {
		id: -1
	},
	history: {},
	container: {
		background: '#ffffff',
		backgroundFull: '',
		borderWidth: '',
		borderStyle: 'solid',
		borderColor: '',
		pallette: '',
		margin: "0px auto",
		commonStyle: {
			box: boxDefault,
			text: textDefault,
			button: buttonDefault,
			link: linkDefault,
			partition: partitionDefault,
			outer: {
				paddingTop: "0",
				paddingBottom: "0",
			}
		}
	},
	service: {
		totalSize: 0,
		msg: msg
	},
	ui: {
		conetentsLoading: [],
		isContentsLoading: true,
		addContentCanDrop: false,
		contentsSaving: false,
		showHistory: false,
		showsSidebar: false,
		dialog: {
			show: false,
			msg: '',
			callback: null
		},
		screenMode: 'desktop',
	},
	option: option,
	defaultShop: {
		mall_id: '',
		shop_no: -1,
		shop_name: '',
		base_domain: '',
		primary_domain: '',
		language: '',
		currency: '',
		use_reference_currency: true,
		company_name: '',
		address: '',
		phone: '',
		list_id: -1,
		is_default: false,
	},
	shops: [],
};

const editor = createReducer<editorState, editorAction>(initialState, {
	[actions.GET_CONTENTS]: (state) => ({
		...state,
		contents: []
	}),
	[actions.GET_CONTENTS_SUCCESS]: (state, action) => ({
		...state,
		contents : action.payload,
	}),
	[actions.GET_CONTENTS_ERROR]: (state, action) => ({
		...state,
		contents: []
	}),
	[actions.SWITCH_TEST_GROUP]: (state, action) => ({
		...state,
		emailId: action.payload,
	}),
	[actions.SET_TEST_GROUP]: (state, action) => ({
		...state,
		testGroup: action.payload,
	}),
	[actions.SYNC_TEST_GROUP_CONTENTS]: (state, action) => ({
		...state,
		emailId: action.payload,
	}),
	[actions.SET_EMAIL_ID]: (state, action) => ({
		...state,
		emailId: action.payload
	}),
	[actions.GET_EMAIL]: (state) => ({
		...state,
		email: {
			id: -1
		}
	}),
	[actions.GET_EMAIL_SUCCESS]: (state, action) => ({
		...state,
		email: action.payload,
	}),
	[actions.GET_EMAIL_ERROR]: (state, action) => ({
		...state,
		email: {
			id: -1
		}
	}),
	[actions.GET_CONTAINER]: (state) => ({
		...state,
	}),
	[actions.GET_CONTAINER_SUCCESS]: (state, action) => ({
		...state,
		container: action.payload,
	}),
	[actions.GET_CONTAINER_ERROR]: (state, action) => ({
		...state,
	}),
	[actions.EDIT_CONTAINER]: (state, action) => ({
		...state,
		container: action.payload
	}),
	[actions.GET_HISTORY]: (state) => ({
		...state,
	}),
	[actions.GET_HISTORY_SUCCESS]: (state, action) =>
	{
		if (action.payload.offset === 0) {
			return {
				...state,
				history: action.payload,
			}
		} else {
			return {
				...state,
				history: {
					total: action.payload.total,
					limit: action.payload.limit,
					offset: action.payload.offset,
					items: state.history.items?.concat(action.payload.items),
				}
			}
		}
	},
	[actions.GET_HISTORY_ERROR]: (state, action) => ({
		...state,
	}),
	[actions.GET_FILESIZE]: (state) => ({
		...state,
	}),
	[actions.GET_FILESIZE_SUCCESS]: (state, action) => ({
		...state,
		service: {
			...state.service, 
			totalSize: action.payload.totalSize
		},
	}),
	[actions.GET_FILESIZE_ERROR]: (state, action) => ({
		...state,
	}),
	[actions.APPLY_FILESIZE]: (state) => ({
		...state,
	}),
	[actions.EDIT_CONTENT]: (state, action) => ({
		...state
	}),
	[actions.MOVE_CONTENT]: (state, action) => ({
		...state
	}),
	[actions.SELECT_CONTENT]: (state, action) => ({
		...state,
		selectedContentId: action.payload,
		prevSelectedContentId: state.selectedContentId
	}),	
	[actions.ADD_CONTENT_CANDROP]: (state, action) => ({
		...state,
		ui: produce(state.ui, (draft: any) => {
			draft.addContentCanDrop = action.payload;
		})
	}),
	[actions.SAVE_CONTENTS]: (state, action) => ({
		...state,
	}),
	[actions.SAVE_CONTENTS_SUCCESS]: (state, action) => ({
		...state,
	}),
	[actions.SAVE_CONTENTS_ERROR]: (state, action) => ({
		...state,
	}),
	[actions.TOGGLE_IS_SAVING]: (state, action) => {
		return ({
		...state,
		ui: produce(state.ui, (draft: any) => {
			draft.contentsSaving = action.payload;
		})
	})},
	[actions.TOGGLE_IS_CONTENTS_LOADING]: (state, action) => {
		return ({
		...state,
		ui: produce(state.ui, (draft: any) => {
			draft.isContentsLoading = action.payload;
		})
	})},
	[actions.TOGGLE_CONTENTS_TARGET_LOADING]: (state, action) => {
		const { target, isLoading } = action.payload;
		return ({
		...state,
		ui: produce(state.ui, (draft: any) => {
			if (isLoading) {
				draft.conetentsLoading[target] = isLoading;
			} else {
				delete draft.conetentsLoading[target];
			}
		})
	})},
	[actions.SET_MARKED_TOOLBAR]: (state, action) => {
		if(JSON.stringify(state.markedToolbar) == JSON.stringify(action.payload)){
			return state;
		}
		return ({
		...state,
		markedToolbar: {
			...action.payload
		}
	})},
	[actions.TOGGLE_SHOW_HISTORY]: (state, action) => {
		return ({
		...state,
		ui: produce(state.ui, (draft: any) => {
			draft.showHistory = action.payload;
		})
	})},
	[actions.GET_SYSTEMFIELDS]: (state) => ({
		...state,
	}),
	[actions.GET_SYSTEMFIELDS_SUCCESS]: (state, action) => ({
		...state,
		systemFields: action.payload,
	}),
	[actions.GET_SYSTEMFIELDS_ERROR]: (state, action) => ({
		...state,
		systemFields: []
	}),
	[actions.GET_LISTVARS]: (state) => ({
		...state,
	}),
	[actions.GET_LISTVARS_SUCCESS]: (state, action) => ({
		...state,
		listVars: action.payload,
	}),
	[actions.GET_LISTVARS_ERROR]: (state, action) => ({
		...state,
		listVars: []
	}),
	[actions.GET_LISTINFO]: (state) => ({
		...state,
	}),
	[actions.GET_LISTINFO_SUCCESS]: (state, action) => ({
		...state,
		listInfo: action.payload,
	}),
	[actions.GET_LISTINFO_ERROR]: (state, action) => ({
		...state,
		listInfo: {
			id: -1
		}
	}),
	[actions.SET_SHOPS]: (state, action) => ({
		...state,
		shops: action.payload,
	}),
	[actions.SET_DEFAULT_SHOP]: (state, action) => ({
		...state,
		defaultShop: action.payload,
	}),
	[actions.INIT_SIDEBAR]: (state, action) => {
		const showsSidebar = window.sessionStorage.getItem('showsSidebar') !== 'false';
		return {
			...state,
			ui: {
				...state.ui,
				showsSidebar,
			}
		}
	},
	[actions.SHOW_SIDEBAR]: (state, action) => {
		window.sessionStorage.setItem('showsSidebar', 'true');
		return {
			...state,
			ui: {
				...state.ui,
				showsSidebar: true,
			}
		}
	},
	[actions.HIDE_SIDEBAR]: (state, action) => {
		window.sessionStorage.setItem('showsSidebar', 'false');
		return {
			...state,
			ui: {
				...state.ui,
				showsSidebar: false,
			}
		}
	},
	[actions.DIALOG_SHOW]: (state, action) => {
		return {
			...state,
			ui: {
				...state.ui,
				dialog: {
					show: true,
					msg: action.payload.msg,
					msgsub: action.payload.msgsub,
					callback: action.payload.callback,
				}
			}
		}
	},
	[actions.DIALOG_HIDE]: (state, action) => {
		return {
			...state,
			ui: {
				...state.ui,
				dialog: {
					show: false,
					msg: '',
					callback: null
				}
			}
		}
	},
	[actions.CHANGE_SCREENMODE]: (state, action) => {
		return {
			...state,
			ui: {
				...state.ui,
				screenMode: action.payload
			}
		}
	},
	[actions.REQUEST_OPEN_PREVIEW]: (state, action) => {
		return {
			...state,
			ui: {
				...state.ui,
				isLoadingPreview: true,
			}
		}
	},
	[actions.FINISH_LOADING_PREVIEW]: (state, action) => {
		return {
			...state,
			ui: {
				...state.ui,
				isLoadingPreview: false,
			}
		}
	},
});

export default editor;